+(function ($) {
  "use strict";

  function initializeSlickSliders() {
    // Used on the homepage landing section
    $(".slick-slider.slick-scroll").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 8000,
      infinite: true,
      dots: false,
    });
    // Used to transition images in the featured sections
    $(".slick-slider.slick-fade").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      infinite: true,
      dots: false,
      fade: true,
      lazyLoad: "progressive",
    });
  }

  // Assure plugin output compatability between Bootstrap 4 and 5
  function updateBootstrapCompat() {
    var updatedAttrs = ["target", "toggle", "dismiss"];
    updatedAttrs.forEach(function (attr) {
      $("[data-" + attr + "]").each(function () {
        var $el = $(this);
        $el.attr("data-bs-" + attr, $el.attr("data-" + attr));
      });
    });
  }

  initializeSlickSliders();
  updateBootstrapCompat();
})(jQuery);
